import React, {memo} from 'react';
import  './loader.css';
const loader = ({text}) =>
{
    return (<div id="outer-loader">
    <div id="inner-loader"><img alt={text} src="/favicon.ico" />{text}</div>
    </div>);
}

export default memo(loader);